/**
 * Boho Magic - cart drawer upsell tag (2026-10-21)
 *
 * WHY: we need an exact count of every purchase that came from our cart drawer
 * "Complete the Look" block (snippets/cart-drawer-upsell.liquid), not only gift
 * boxes. The drawer items also sell from their own product pages, so SKUs alone
 * can't tell drawer purchases apart.
 *
 * WHAT: every item added from that block gets the hidden line-item property
 *   _bm_source = drawer_upsell
 * It travels with the line into checkout and the order, so each order shows
 * exactly which lines came from the drawer. Keys starting with "_" are hidden in
 * the cart (snippets/cart-item.liquid skips them) and in Shopify checkout.
 *
 * HOW: the drawer's click handler lives at the end of assets/theme.js
 * (.cart-drawer-upsell__add-btn -> fetch("/cart/add.js", {body: {id, quantity}})).
 * Rather than edit that large file, this script:
 *   1. notes the variant id when a shopper clicks a drawer "Add" button
 *      (capture phase, so it runs before theme.js's handler), and
 *   2. adds the property to the /cart/add.js request theme.js then sends for
 *      that same variant within 5 seconds.
 * Every other request passes through untouched. On any error the request is sent
 * unchanged, so the drawer keeps working exactly as before.
 *
 * Loaded from layout/theme.liquid (comment "BM 2026-10-21: drawer upsell tag").
 * To remove: delete that script tag.
 */
(function () {
  'use strict';

  if (window.BM_DRAWER_TAG_INIT) return;
  window.BM_DRAWER_TAG_INIT = true;
  if (typeof window.fetch !== 'function') return;

  var PROPERTY_KEY = '_bm_source';
  var PROPERTY_VALUE = 'drawer_upsell';
  var MATCH_WINDOW_MS = 5000;
  var pending = {};

  document.addEventListener('click', function (evt) {
    var target = evt.target;
    var btn = target && target.closest ? target.closest('.cart-drawer-upsell__add-btn') : null;
    if (!btn) return;
    var variantId = Number(btn.getAttribute('data-upsell-variant-id'));
    if (variantId) pending[variantId] = Date.now();
  }, true);

  var originalFetch = window.fetch;

  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/add(\.js)?($|\?)/.test(url) && init && typeof init.body === 'string') {
        var body = JSON.parse(init.body);
        var variantId = body ? Number(body.id) : 0;
        if (variantId && pending[variantId] && Date.now() - pending[variantId] < MATCH_WINDOW_MS) {
          delete pending[variantId];
          var properties = {};
          if (body.properties && typeof body.properties === 'object') {
            for (var p in body.properties) {
              if (Object.prototype.hasOwnProperty.call(body.properties, p)) {
                properties[p] = body.properties[p];
              }
            }
          }
          properties[PROPERTY_KEY] = PROPERTY_VALUE;
          body.properties = properties;

          var newInit = {};
          for (var k in init) {
            if (Object.prototype.hasOwnProperty.call(init, k)) newInit[k] = init[k];
          }
          newInit.body = JSON.stringify(body);
          init = newInit;
        }
      }
    } catch (e) {
      // Tracking must never break the cart: fall through and send the request unchanged.
    }
    return originalFetch.call(window, input, init);
  };
})();